import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
// import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react';
import CounterStoreContext from '../../stores/SavingCapacityStore';

// core components
import HeaderSection from '../../components/header/HeaderSection';
// import CustomSlider from '../../components/CustomSlider/CustomSlider';
import CustomInput from '../../components/CustomInput/CustomInput';
import GraphIncomeExpense from '../../components/GraphIncomeExpense/GraphIncomeExpense';

const useStyles = makeStyles(theme => ({
  root: {
    // display: 'flex',
  },
  formControl: {
    // margin: theme.spacing(3),
  },
  gridComponent: {
    flexGrow: 1
  },
  gridPaper: {
    paddingLeft: '15px',
    paddingRight: '15px',
    textAlign: 'justify'
  },
  gridLabel: {
    color: '#000',
    fontSize: '20px',
    lineHeight: '135%',
    width: '100%',
    wordBreak: 'break-word',
    margin: '0px',
    fontWeight: '600'
  }
}));

const SectionExpenses = observer(({ lang }) => {
  const counterStore = useContext(CounterStoreContext);
  const classes = useStyles();

  const handleCustomSliderValue = value => {
    counterStore.setValue('expenses', value);
  };

  return (
    <>
      <HeaderSection tittle={lang.expenseTittle} />

      <div className={classes.gridComponent}>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <div className={classes.gridPaper}>
              <p
                style={{
                  color: '#000',
                  fontSize: '20px',
                  lineHeight: '135%',
                  width: '100%',
                  wordBreak: 'break-word',
                  margin: '0px',
                  fontWeight: '600'
                }}
              >
                {lang.expenseByMonth}
              </p>
              <p style={{ color: '#717171' }}>{lang.expenseDescription}</p>
              <br />
              <CustomInput
                defaultValue={counterStore.expenses}
                handleChangeValue={handleCustomSliderValue}
              />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div className={classes.gridPaper}>
              <p
                style={{
                  color: '#000',
                  fontSize: '20px',
                  lineHeight: '135%',
                  width: '100%',
                  wordBreak: 'break-word',
                  margin: '0px',
                  fontWeight: '600',
                  textAlign: 'center'
                }}
              >
                {lang.expenseByYear}
              </p>
              <br />
              <GraphIncomeExpense lang={lang} />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
});

export default SectionExpenses;
